export const dayMonthFormatter = new Intl.DateTimeFormat("no-NB", {
  day: "numeric",
  month: "numeric",
});

export const currencyFormatter = new Intl.NumberFormat("nb-NO", {
  style: "currency",
  currency: "NOK",
});
